/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import {
  Assignment,
  CardTravel,
  Category,
  ContactPhone,
  Dashboard,
  Equalizer,
  ExitToApp,
  Group,
  LocalOffer,
  Store,
  Straighten,
  ViewCompact,
  ViewModule,
} from "@material-ui/icons";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { ROLES } from "../../../../../utils/constants";
import { checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const adminAccess =
    loggedUser?.role?.rango === ROLES.SUPER_ADMIN ||
    loggedUser?.role?.rango === ROLES.ADMIN;

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <Equalizer />
            </span>
            <span className="menu-text">Visión Global</span>
          </NavLink>
        </li>
        <li className="menu-section">
          <h4 className="menu-text">COMERCIAL</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/clientes",
            false
          )} ${getMenuItemActive("/editar-cliente", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/clientes">
            <span className="menu-icon">
              <ContactPhone />
            </span>
            <span className="menu-text">Clientes</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/proveedores",
            false
          )} ${getMenuItemActive("/editar-proveedor", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/proveedores">
            <span className="menu-icon">
              <Store />
            </span>
            <span className="menu-text">Proveedores</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/ofertas", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/ofertas">
            <span className="menu-icon">
              <LocalOffer />
            </span>
            <span className="menu-text">Ofertas</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/admins",
            false
          )} ${getMenuItemActive("/edit-admin", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admins">
            <span className="menu-icon">
              <Assignment />
            </span>
            <span className="menu-text">Reports</span>
          </NavLink>
        </li>
        {adminAccess && (
          <>
            <li className="menu-section">
              <h4 className="menu-text">ADMINISTRACIÓN</h4>
              <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/usuarios", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/usuarios">
                <span className="menu-icon">
                  <Group />
                </span>
                <span className="menu-text">Usuarios</span>
              </NavLink>
            </li>
            <hr className="menu-separator" />
            <li
              className={`menu-item ${getMenuItemActive("/productos", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/productos">
                <span className="menu-icon">
                  <Dashboard />
                </span>
                <span className="menu-text">Productos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/familias-productos",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/familias-productos">
                <span className="menu-icon">
                  <Category />
                </span>
                <span className="menu-text">Famílias de Productos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/tipos-unidades-productos",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/tipos-unidades-productos">
                <span className="menu-icon">
                  <Straighten />
                </span>
                <span className="menu-text">
                  Tipos de Unidades de Productos
                </span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/marcas-productos",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/marcas-productos">
                <span className="menu-icon">
                  <Straighten />
                </span>
                <span className="menu-text">Marcas de Producatos</span>
              </NavLink>
            </li>
            <hr className="menu-separator" />
            <li
              className={`menu-item ${getMenuItemActive("/partidas", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/partidas">
                <span className="menu-icon">
                  <CardTravel />
                </span>
                <span className="menu-text">Partidas</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/categorias-partidas",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/categorias-partidas">
                <span className="menu-icon">
                  <ViewModule />
                </span>
                <span className="menu-text">Categorías de Partidas</span>
              </NavLink>
            </li>
            <hr className="menu-separator" />
            <li
              className={`menu-item ${getMenuItemActive(
                "/tipos-proveedores",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/tipos-proveedores">
                <span className="menu-icon">
                  <ViewCompact />
                </span>
                <span className="menu-text">Tipos de Proveedores</span>
              </NavLink>
            </li>
          </>
        )}

        <li className="menu-section"></li>
        <li
          className={`menu-item`}
          aria-haspopup="true"
          style={{
            backgroundColor: "#ff0000",
          }}
        >
          <NavLink className="menu-link" to="/logout">
            <span className="menu-icon">
              <ExitToApp />
            </span>
            <span className="menu-text">Logout</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
